import { Outlet } from 'react-router';
import { ContingenciaBanner } from './ContingenciaBanner.js';
import { Header } from './Header.js';
import { Sidebar } from './Sidebar.js';

export function AppShell() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <ContingenciaBanner />
      <div className="flex flex-1">
        <Sidebar />
        <main className="flex-1 bg-slate-50 p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
